// uses ./appsListFilters.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import collectEnabledFilters from '../../common/collectEnabledFilters';
import AppsListFilter from './AppsListFilter';
import AppSuggestionSection from './SuggestionSection';
import SearchField from './SearchField';
import { resetFilters, toggleFilters } from './appsListFiltersActionCreators';
import { initialState } from '../appsListReducer';
import { RequiresConnect } from '../../common/platform/PlatformTools';

const bodyClassName = 'appsListFilters-overlaid';

function updateBodyClassList(expanded) {
    if (expanded) {
        document.body.classList.add(bodyClassName);
    } else {
        document.body.classList.remove(bodyClassName);
    }
}

class AppsListFilters extends React.Component {
    constructor(props) {
        super(props);
        updateBodyClassList(props.expanded);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.expanded !== this.props.expanded) {
            updateBodyClassList(this.props.expanded);
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.dispatchToggleFilters(e);
    }

    render() {
        if (!this.props.isUserFetched) {
            return null;
        }

        // FIXME: this is wrong place to do this kind of things
        const filters = collectEnabledFilters(this.props.filters, this.props.user);
        const initialFilters = collectEnabledFilters(initialState.filters, this.props.user);

        const resetButton =
            isEqual(filters, initialFilters) && isEqual(this.props.search, initialState.search) ? (
                ''
            ) : (
                <button
                    type="button"
                    className="sg-button-link appsListFilters-reset"
                    onClick={this.props.dispatchResetFilters}
                >
                    Clear
                </button>
            );

        const sectionClassName = `sg-box-overlay appsListFilters${this.props.expanded ? ' expanded' : ''}${
            this.props.user.exists ? ' with-suggestion' : ''
        }`;

        return (
            <section className={sectionClassName} data-pendoid="allapps&Integration-Filters">
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <div className="appsListFilters-content-wrapper">
                        <div className="appsListFilters-content" data-pendoid="allapps&Integration-Filters">
                            <h4 className="appsListFilters-title">
                                <span>Filters</span>
                                {resetButton}
                            </h4>
                            <SearchField search={this.props.search} />
                            {Object.keys(filters).map((filterGroup) =>
                                filterGroup === 'status' ? (
                                    <RequiresConnect key={filterGroup}>
                                        <AppsListFilter
                                            name={filterGroup}
                                            filters={filters[filterGroup]}
                                            unifiedPlatform={this.props.unifiedPlatform}
                                            initialExpanded={initialState.expandedFilters.includes(filterGroup)}
                                        />
                                    </RequiresConnect>
                                ) : (
                                    <AppsListFilter
                                        key={filterGroup}
                                        name={filterGroup}
                                        filters={filters[filterGroup]}
                                        unifiedPlatform={this.props.unifiedPlatform}
                                        initialExpanded={initialState.expandedFilters.includes(filterGroup)}
                                    />
                                )
                            )}
                            <button
                                type="button"
                                className="sg-button-primary appsListFilters-submit"
                                onClick={this.props.dispatchToggleFilters}
                            >
                                Done
                            </button>
                        </div>
                    </div>
                </form>
                <AppSuggestionSection userExists={this.props.user.exists} />
            </section>
        );
    }
}

AppsListFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    unifiedPlatform: PropTypes.bool.isRequired,
    user: PropTypes.object,
    expanded: PropTypes.bool.isRequired,
    dispatchToggleFilters: PropTypes.func.isRequired,
    dispatchResetFilters: PropTypes.func.isRequired,
    search: PropTypes.string.isRequired,
    isUserFetched: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
    user: state.user,
    apps: state.appsList.apps,
    unifiedPlatform: state.user.unifiedPlatform,
    isUserFetched: !!state.user.lastFetch,
});

const mapDispatchToProps = {
    dispatchToggleFilters: toggleFilters,
    dispatchResetFilters: (e) => {
        e.stopPropagation();

        return resetFilters();
    },
};

export default connect(mapStateToProps, mapDispatchToProps)(AppsListFilters);
